// extracted by mini-css-extract-plugin
module.exports = {"lds-heart":"style_lds-heart__-QYLT","div-after":"style_div-after__2xG0h","div-before":"style_div-before__pbzbH"};